module.exports = __webpack_public_path__ + "img/whatsapp.ab73dabb.svg";